"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupMember = void 0;
var tslib_1 = require("tslib");
var MemberRole_1 = require("./MemberRole");
var Member_1 = require("./Member");
var MemberDTO_1 = require("./MemberDTO");
var GroupMember = /** @class */ (function (_super) {
    tslib_1.__extends(GroupMember, _super);
    function GroupMember() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupMember.prototype.isAnonymous = function () {
        return Member_1.isAnonymous(this.member);
    };
    /**
     * the member's relationship with the group !== NONE
     * @return {boolean}
     */
    GroupMember.prototype.relatedToGroup = function () {
        return Member_1.isGroupMember(this.member);
    };
    /**
     * RelationshipWithGroup == JOINED
     * @return {boolean}
     */
    GroupMember.prototype.isJoined = function () {
        return MemberRole_1.isJoined(this.member);
    };
    GroupMember.prototype.isMember = function () {
        return MemberRole_1.isMember(this.member);
    };
    GroupMember.prototype.isSiteAdmin = function () {
        return MemberRole_1.hasSiteAdminRole(this.member.roles);
    };
    GroupMember.prototype.isOwner = function (group) {
        if (!group) {
            return false;
        }
        return MemberRole_1.isOwner(group, this.member);
    };
    GroupMember.prototype.isAdmin = function () {
        return MemberRole_1.isAdmin(this.member);
    };
    GroupMember.prototype.isMe = function (other) {
        return this.getId() === other.siteMemberId;
    };
    GroupMember.prototype.getRoles = function (group) {
        return this.isOwner(group) ? [MemberRole_1.GROUP_OWNER] : this.member.roles || [];
    };
    GroupMember.prototype.hasRole = function (role) {
        return this.getRoles().includes(role);
    };
    GroupMember.prototype.getRelation = function () {
        return this.member.relationship;
    };
    GroupMember.prototype.getJoinDate = function () {
        return this.member.joinedOn;
    };
    GroupMember.prototype.getMember = function () {
        return this.member;
    };
    return GroupMember;
}(MemberDTO_1.MemberDTO));
exports.GroupMember = GroupMember;
//# sourceMappingURL=GroupMember.js.map